import { KeyValueObject } from "../types/general";
import { getColorVariable } from "../utils/helper";
import { TooltipProps } from "./tooltip";

export function getBorderRadius(layoutTheme: TooltipProps["theme"], theme: any): KeyValueObject {
    if (layoutTheme === "standalone") {
        return {
            borderRadius: theme.borderRadius.lg,
        };
    }
    return {
        borderRadius: theme.borderRadius.DEFAULT,
    };
}

export function getBackgroundColor(color: TooltipProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            backgroundColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[400],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
        };
    }
    return {
        backgroundColor: theme.colors.gray[950],
    };
}

export function getColor(color: TooltipProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            color: getColorVariable(color, theme, {
                gray: theme.colors.white,
                white: theme.colors.gray[950],
                colorize: theme.colors.white,
                default: theme.colors.white,
            }),
        };
    }
    return { color: theme.colors.white };
}

export function getBodyFillColor(color: TooltipProps["color"], theme: any): KeyValueObject {
    if (color) {
        return {
            fill: getColorVariable(color, theme, {
                gray: theme.colors.gray[400],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
        };
    }
    return {
        fill: theme.colors.gray[950],
    };
}
